// Start an embedded Checkout Session for a marketplace listing. Shared by the
// storefront, the item detail sheet and the "Try it" preview banner.
import { gathrxrAuthHeader } from '../../utils/quotaHeaders';
import type { EmbeddedSession } from '../../services/checkout';

export async function startListingCheckout(listingId: string): Promise<EmbeddedSession> {
  const headers = await gathrxrAuthHeader();
  const res = await fetch('/api/marketplace/checkout', {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ listingId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.clientSecret) throw new Error(data?.error || 'Could not start checkout.');
  return data as EmbeddedSession;
}

export const formatMoney = (cents: number, currency = 'usd') =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100);
